import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails";

// Connects to data-controller="clickable"
export default class extends Controller {
  static values = { url: String }
  connect() {
  }

  navigate(){
    Turbo.visit(this.urlValue)
  }
}
